import { Locales, Trad } from '@types';

const tradsData = {
  'common.close': { [Locales.EN]: 'Close', [Locales.FR]: 'Fermer' },
  'footer.copyright': {
    [Locales.EN]: 'All rights reserved.',
    [Locales.FR]: 'Tous droits réservés.',
  },
  // 'footer.madeBy': {
  //   [Locales.EN]: 'Made with ♥︎ by me.',
  //   [Locales.FR]: 'Site créé avec ♥︎ par moi.',
  // },
  'footer.usage': {
    [Locales.EN]:
      'Unauthorized use, copying, or distribution of the photos displayed on this website is strictly prohibited.',
    [Locales.FR]:
      'Toute utilisation, copie ou distribution non autorisée des images affichées sur ce site est strictement interdite.',
  },
  'gallery.colors': { [Locales.EN]: 'colors', [Locales.FR]: 'couleurs' },
  'gallery.colors.bnw': {
    [Locales.EN]: 'black & white',
    [Locales.FR]: 'noir & blanc',
  },
  'gallery.colors.color': {
    [Locales.EN]: 'color',
    [Locales.FR]: 'couleur',
  },
  'gallery.empty': {
    [Locales.EN]: 'No photos in this gallery.',
    [Locales.FR]: 'Aucune photo dans cette galerie.',
  },
  'gallery.groupBy': { [Locales.EN]: 'group by', [Locales.FR]: 'groupes' },
  'gallery.groupBy.all': { [Locales.EN]: 'all', [Locales.FR]: 'tout' },
  'gallery.groupBy.locations': {
    [Locales.EN]: 'location',
    [Locales.FR]: 'lieux',
  },
  'gallery.groupBy.years': { [Locales.EN]: 'year', [Locales.FR]: 'années' },
  'home.bio': {
    [Locales.EN]:
      '<p>Hi there, I’m <span class="text-accent">Marc Malignan</span> — web <a class="border-b border-dashed" href="https://cv.marcmalignan.com/" target="_blank">developer</a> and amateur photographer, based in <span class="text-accent">Paris</span>.</p>' +
      '<p>My journey with photography started in 2023, during a transformative visit to the <a class="text-accent hover:border-b" href="https://www.rencontres-arles.com/" target="_blank">Rencontres d’Arles</a> festival. I quickly bought a camera, went outside to shoot and was immediately hooked. I’ve been passionately pursuing this craft ever since.</p>' +
      '<p>Why an online <span class="text-accent">portfolio</span> though?</p>' +
      '<p>Like many creatives these days, I’ve been hit with a form of "social media fatigue", frustrated by their algorithms and fast-paced rhythm. I wanted to create an alternative space where I could display my photos as a whole. A <span class="text-accent">free space</span> for my artistic expression.' +
      '<p>Here you’ll find photo albums from <a class="text-accent hover:border-b" href="/locations/paris">Paris</a> and my latest travels across <a class="text-accent hover:border-b" href="/locations/europe">Europe</a> and <a class="text-accent hover:border-b" href="/locations/asia">Asia</a>, along with a few ongoing themed <a class="text-accent hover:border-b" href="/series">series</a>.</p>' +
      '<p>Thank you sincerely for visiting! Feel free to reach out if you’d like to connect.</p>',
    [Locales.FR]:
      '<p>Bonjour, je suis <span class="text-accent">Marc Malignan</span> — <a class="border-b border-dashed" href="https://cv.marcmalignan.com/" target="_blank">développeur</a> web et photographe amateur, à <span class="text-accent">Paris</span>.</p>' +
      '<p>Mon intérêt pour la photographie a débuté en 2023, lors d’un voyage initiatique au festival des <a class="text-accent hover:border-b" href="https://www.rencontres-arles.com/" target="_blank">Rencontres d’Arles</a>. J’ai immédiatement acheté un appareil à mon retour et j’étais conquis dès les premières sorties photo. Je pratique avec passion depuis.</p>' +
      '<p>Pourquoi un <span class="text-accent">portfolio</span> en ligne ?</p>' +
      '<p>Comme de nombreux créatifs, j’ai récemment ressenti une forme de lassitude envers les réseaux sociaux, frustré par leurs algorithmes et leur rythme effréné. Je voulais créer un espace alternatif dans lequel je pourrais présenter mes photos de manière cohérente. Un <span class="text-accent">espace de liberté</span> pour mon expression artistique.' +
      '<p>Vous trouverez ici des albums photos de <a class="text-accent hover:border-b" href="/locations/paris">Paris</a> et de mes derniers voyages à travers l’<a class="text-accent hover:border-b" href="/locations/europe">Europe</a> et l’<a class="text-accent hover:border-b" href="/locations/asia">Asie</a>, ainsi que quelques <a class="text-accent hover:border-b" href="/series">séries</a> thématiques.</p>' +
      '<p>Merci beaucoup de votre visite ! N’hésitez pas à me contacter si vous voulez échanger.</p>',
  },
  'nav.button': { [Locales.EN]: 'Menu', [Locales.FR]: 'Menu' },
  'nav.home': { [Locales.EN]: 'Home', [Locales.FR]: 'Accueil' },
  'nav.links.email': { [Locales.EN]: 'email', [Locales.FR]: 'e-mail' },
  'nav.locations.asia': { [Locales.EN]: 'Asia', [Locales.FR]: 'Asie' },
  'nav.locations.europe': { [Locales.EN]: 'Europe', [Locales.FR]: 'Europe' },
  'nav.locations.paris': { [Locales.EN]: 'Paris', [Locales.FR]: 'Paris' },
  'nav.series': { [Locales.EN]: 'Series', [Locales.FR]: 'Séries' },
};

export type TradKeys = keyof typeof tradsData;
export const trads = tradsData as Record<TradKeys, Trad>;
